import { render } from 'preact';
import { useEffect } from 'preact/hooks';
import { me, refreshMe, signOut } from './session';
import { Link, Loading, navigate, route, Toasts } from './ui';
import { Landing } from './pages/Landing';
import { Home } from './pages/Home';
import { Browse } from './pages/Browse';
import { CreateGame } from './pages/Create';
import { Account } from './pages/Account';
import { Stories } from './pages/Stories';
import { StoryEditor } from './pages/StoryEditor';
import { Templates, TemplateDetail } from './pages/Templates';
import { Admin } from './pages/Admin';
import { Simulate } from './pages/Simulate';
import { GamePage } from './game/Game';
import './styles.css';

function Nav() {
	const m = me.use();
	const user = m?.user;
	return (
		<header class="topbar">
			<Link href={user ? '/home' : '/'} class="brand">
				<img src="/icon.svg" alt="" width="28" height="28" />
				<span>Shifting Saga</span>
			</Link>
			{user ? (
				<nav class="topnav">
					<Link href="/browse">Games</Link>
					<Link href="/stories">Stories</Link>
					<Link href="/templates">Templates</Link>
					{user.isAdmin ? <Link href="/admin">Admin</Link> : null}
					<Link href="/account" class="me-link">
						{user.displayName}
					</Link>
					<button
						class="linkish"
						onClick={async () => {
							await signOut();
							navigate('/');
						}}
					>
						Sign out
					</button>
				</nav>
			) : (
				<nav class="topnav">
					<Link href="/browse">Browse games</Link>
					<Link href="/templates">Templates</Link>
				</nav>
			)}
		</header>
	);
}

function Router() {
	const path = route.use();
	const m = me.use();
	const url = new URL(path, location.origin);
	const p = url.pathname;
	if (!m) return <Loading />;
	const signedIn = !!m.user;
	const needAuth = (el: preact.JSX.Element) => (signedIn ? el : <Landing next={path} />);
	let mm: RegExpMatchArray | null;
	if (p === '/' || p === '') return signedIn ? <Home /> : <Landing />;
	if (p === '/home') return needAuth(<Home />);
	if (p === '/browse') return <Browse />;
	if (p === '/create') return needAuth(<CreateGame />);
	if (p === '/account') return needAuth(<Account />);
	if (p === '/stories') return needAuth(<Stories />);
	if ((mm = p.match(/^\/stories\/([^/]+)$/))) return needAuth(<StoryEditor id={mm[1]} />);
	if (p === '/templates') return <Templates />;
	if ((mm = p.match(/^\/templates\/([^/]+)$/))) return <TemplateDetail id={mm[1]} />;
	if (p === '/admin') return needAuth(<Admin />);
	if (p === '/billing/simulate') return needAuth(<Simulate token={url.searchParams.get('token') ?? ''} />);
	if ((mm = p.match(/^\/g\/([A-Za-z0-9-]+)$/))) return needAuth(<GamePage code={mm[1].replace('-', '').toUpperCase()} />);
	return (
		<main class="page">
			<h1>Not found</h1>
			<p>
				<Link href="/">Go home</Link>
			</p>
		</main>
	);
}

function App() {
	useEffect(() => {
		refreshMe().catch(() => me.set({ user: null }));
	}, []);
	const path = route.use();
	const inGame = path.startsWith('/g/');
	return (
		<div class={`app ${inGame ? 'app-game' : ''}`}>
			<Nav />
			<Router />
			<Toasts />
		</div>
	);
}

render(<App />, document.getElementById('app')!);

if ('serviceWorker' in navigator && location.protocol === 'https:') navigator.serviceWorker.register('/sw.js').catch(() => undefined);
